module.exports = __webpack_public_path__ + "static/media/illustration-01.157dd82e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/illustration-01.png
// module id = 34
// module chunks = 0